export default [
  {
    name: "courierJSON",
    type: "font",
    path: "/fonts/courier-new-regular.json",
  }
];
